export default __webpack_public_path__ + "static/planet_escape_logo-c9b0b25fae700650c6570c33d0d47c38.png";